"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionRemoveUndefinedKey = exports.FunctionCheckLoadPhoneNumberCountry = exports.FunctionGetModelError = exports.FunctionAdaptorToNormalForm = exports.FunctionCheckNoSpacialCharacter = exports.FunctionCheckNoSpace = exports.FunctionCheckMinimum = exports.FunctionCheckLimit = exports.FunctionCheckEmail = exports.FunctionCheckIsNumber = exports.FunctionAddUrlToFile = exports.FunctionCheckIsRequired = exports.FunctionCheckThaiNationalID = exports.FunctionCalurate = exports.FunctionDivide = exports.FunctionMultiple = exports.FunctionMinus = exports.FunctionSum = void 0;
const type_1 = require("../../../type");
const FunctionSum = (input) => {
    if (toString.call(input) !== "[object Array]")
        return false;
    let total = 0;
    for (let i = 0; i < input.length; i++) {
        if (isNaN(input[i])) {
            continue;
        }
        total += Number(input[i]);
    }
    return total;
};
exports.FunctionSum = FunctionSum;
const FunctionMinus = (input) => {
    if (toString.call(input) !== "[object Array]")
        return false;
    let total = 0;
    for (let i = 0; i < input.length; i++) {
        if (isNaN(input[i])) {
            continue;
        }
        total -= Number(input[i]);
    }
    return total;
};
exports.FunctionMinus = FunctionMinus;
const FunctionMultiple = (input) => {
    if (toString.call(input) !== "[object Array]")
        return false;
    let total = 1;
    for (let i = 0; i < input.length; i++) {
        if (isNaN(input[i])) {
            continue;
        }
        total *= Number(input[i]);
    }
    return total;
};
exports.FunctionMultiple = FunctionMultiple;
const FunctionDivide = (input) => {
    if (toString.call(input) !== "[object Array]")
        return false;
    let total = input[0];
    for (let i = 1; i < input.length; i++) {
        if (isNaN(input[i])) {
            continue;
        }
        total /= Number(input[i]);
    }
    return total;
};
exports.FunctionDivide = FunctionDivide;
const FunctionCalurate = (value, option, name, sender) => {
    if (value && option) {
        if (typeof option === "string") {
            if (option === "sum") {
                return (0, exports.FunctionSum)(value);
            }
            else if (option === "minus") {
                return (0, exports.FunctionMinus)(value);
            }
            else if (option === "multiple") {
                return (0, exports.FunctionMultiple)(value);
            }
            else if (option === "divide") {
                return (0, exports.FunctionDivide)(value);
            }
        }
        else {
            let original = [];
            let object = {};
            sender.map((s, i) => {
                original.push({ name: s, value: Number(value[i]) || 0 });
                object[s] = Number(value[i]) || 0;
            });
            return option({ value, name, sender, original, object });
        }
    }
    else {
        return "Error";
    }
};
exports.FunctionCalurate = FunctionCalurate;
const FunctionCheckThaiNationalID = (id) => {
    if (id == null || id.length !== 13 || !/^[0-9]\d+$/.test(id))
        return !1;
    let i, sum = 0;
    for (i = 0, sum = 0; i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i);
    }
    let check = (11 - (sum % 11)) % 10;
    if (check === parseInt(id.charAt(12))) {
        return !0;
    }
    return !1;
};
exports.FunctionCheckThaiNationalID = FunctionCheckThaiNationalID;
const FunctionCheckIsRequired = (input, alert) => {
    if (input === 0) {
        return "";
    }
    else if (input === "") {
        return alert;
    }
    else if (input === null) {
        return alert;
    }
    else if (input === undefined) {
        return alert;
    }
    else if (input) {
        return "";
    }
    else {
        return alert;
    }
};
exports.FunctionCheckIsRequired = FunctionCheckIsRequired;
const FunctionAddUrlToFile = (file) => {
    if (file) {
        return URL.createObjectURL(file);
    }
    else {
        return;
    }
};
exports.FunctionAddUrlToFile = FunctionAddUrlToFile;
const FunctionCheckIsNumber = (value, alert, error) => {
    const real_value = Number(value) >= 0 ? Number(value) : value;
    if (value === `-0`) {
        return error;
    }
    else if (isNaN(real_value)) {
        if (value === undefined) {
            return "";
        }
        else {
            return alert;
        }
    }
    else if (real_value >= 0) {
        return "";
    }
    else {
        return error;
    }
};
exports.FunctionCheckIsNumber = FunctionCheckIsNumber;
const FunctionCheckEmail = (input, alert) => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isEmail = emailRegex.test(String(input).toLowerCase());
    if (isEmail) {
        return "";
    }
    else {
        return alert;
    }
};
exports.FunctionCheckEmail = FunctionCheckEmail;
const FunctionCheckLimit = (input, limit, alert) => {
    if (input && limit >= 0) {
        const checkIsString = toString.call(input) === "[object String]";
        const checkIsNumber = toString.call(input) === "[object Number]";
        if (checkIsString) {
            if (input.length > limit) {
                return alert;
            }
            else {
                return "";
            }
        }
        else if (checkIsNumber) {
            if (input > limit) {
                return alert;
            }
            else {
                return "";
            }
        }
        else {
            return "";
        }
    }
    else {
        return "";
    }
};
exports.FunctionCheckLimit = FunctionCheckLimit;
const FunctionCheckMinimum = (input, minimum, alert) => {
    if (input && minimum > 0) {
        const checkIsString = toString.call(input) === "[object String]";
        const checkIsNumber = toString.call(input) === "[object Number]";
        if (checkIsString) {
            if (input.length < minimum) {
                return alert;
            }
            else {
                return "";
            }
        }
        else if (checkIsNumber) {
            if (input < minimum) {
                return alert;
            }
            else {
                return "";
            }
        }
        else {
            return "";
        }
    }
    else {
        return "";
    }
};
exports.FunctionCheckMinimum = FunctionCheckMinimum;
const FunctionCheckNoSpace = (input, alert) => {
    if (input) {
        const checkIsString = toString.call(input) === "[object String]";
        if (checkIsString) {
            if (input.includes(" ")) {
                return alert;
            }
            else {
                return "";
            }
        }
        else {
            return "";
        }
    }
    else {
        return "";
    }
};
exports.FunctionCheckNoSpace = FunctionCheckNoSpace;
const FunctionCheckNoSpacialCharacter = (input, alert) => {
    if (input) {
        const specialCharRegex = /[ !@#$%^&*()_\]\[{}<>,.\/\~+-`]/;
        const checkHasSpecialCharacter = specialCharRegex.test(input);
        if (checkHasSpecialCharacter) {
            return alert;
        }
        else {
            return "";
        }
    }
    else {
        return "";
    }
};
exports.FunctionCheckNoSpacialCharacter = FunctionCheckNoSpacialCharacter;
const FunctionAdaptorToNormalForm = (objects) => {
    if (objects) {
        const new_obejct = {};
        const keys = Object.keys(objects);
        keys.forEach((key, i) => {
            if (objects[key].field_name) {
                new_obejct[objects[key].field_name] = objects[key].value || "";
            }
            else {
                const thisObjects = objects[key];
                const new_step = thisObjects.map((row) => {
                    const new_row = {};
                    const thisKey = Object.keys(row);
                    thisKey.forEach((key) => {
                        new_row[key] = row[key].value || "";
                    });
                    return new_row;
                });
                new_obejct[keys[i]] = new_step;
            }
        });
        return new_obejct;
    }
    else {
        return {};
    }
};
exports.FunctionAdaptorToNormalForm = FunctionAdaptorToNormalForm;
const FunctionGetModelError = (required, number, email, limit, minimum, noSpace, noSpecialCharacter) => {
    let modelError = [];
    if (required) {
        modelError.push(type_1.TYPE_MODEL_ERROR_REQURIED);
    }
    if (number) {
        modelError.push(type_1.TYPE_MODEL_ERROR_NUMBER);
    }
    if (email) {
        modelError.push(type_1.TYPE_MODEL_ERROR_EMAIL);
    }
    if (limit > 0) {
        modelError.push(`${type_1.TYPE_MODEL_ERROR_LIMIT}:${limit}`);
    }
    if (minimum > 0) {
        modelError.push(`${type_1.TYPE_MODEL_ERROR_MINIMUM}:${minimum}`);
    }
    if (noSpace) {
        modelError.push(type_1.TYPE_MODEL_ERROR_NO_SPACE);
    }
    if (noSpecialCharacter) {
        modelError.push(type_1.TYPE_MODEL_ERROR_NO_SPECIAL_CHARACTER);
    }
    return modelError;
};
exports.FunctionGetModelError = FunctionGetModelError;
const FunctionCheckLoadPhoneNumberCountry = (options = [], phoneNumber = "") => {
    const number = phoneNumber.slice(1, phoneNumber.length);
    const checkOne = options
        .map((i) => {
        return i.value;
    })
        .includes(number.slice(0, 1));
    const checkTwo = options
        .map((i) => {
        return i.value;
    })
        .includes(number.slice(0, 2));
    const checkThree = options
        .map((i) => {
        return i.value;
    })
        .includes(number.slice(0, 3));
    const checkFour = options
        .map((i) => {
        return i.value;
    })
        .includes(number.slice(0, 4));
    const checkFive = options
        .map((i) => {
        return i.value;
    })
        .includes(number.slice(0, 5));
    if (checkFive) {
        return {
            country: number.slice(0, 5),
            phone: number.slice(5, number.length),
        };
    }
    else if (checkFour) {
        return {
            country: number.slice(0, 4),
            phone: number.slice(4, number.length),
        };
    }
    else if (checkThree) {
        return {
            country: number.slice(0, 3),
            phone: number.slice(3, number.length),
        };
    }
    else if (checkTwo) {
        return {
            country: number.slice(0, 2),
            phone: number.slice(2, number.length),
        };
    }
    else if (checkOne) {
        return {
            country: number.slice(0, 1),
            phone: number.slice(1, number.length),
        };
    }
    else {
        return { country: "", phone: "" };
    }
};
exports.FunctionCheckLoadPhoneNumberCountry = FunctionCheckLoadPhoneNumberCountry;
const FunctionRemoveUndefinedKey = (obj) => {
    Object.keys(obj).forEach(function (key) {
        if (obj[key] && typeof obj[key] === "object")
            (0, exports.FunctionRemoveUndefinedKey)(obj[key]);
        else if (key === "undefined")
            delete obj[key];
    });
    return obj;
};
exports.FunctionRemoveUndefinedKey = FunctionRemoveUndefinedKey;
